import(/* webpackMode: "eager" */ "/repo/apps/cms/src/app/(front)/page.tsx");
